import React from "react";
import { Route, Switch } from "react-router-dom";
import { PAGE_ROUTES } from "./PageRoutes";
import { MainLayout } from "./MainLayout";

import loadable from "@loadable/component";
const AdminPage = loadable(() => import("../pages/AdminPage"));

export const Router = () => (
  <Switch>
    <Route path="/admin" component={AdminPage} />

    <MainLayout>
      <Switch>{PAGE_ROUTES}</Switch>
    </MainLayout>
  </Switch>
);
